import {observer, observable, classNames, React, Fragment} from '@api'
import {Tooltip2} from '@api'
import {InsertPhoto} from '@material-ui/icons';
import {DropTarget, useVipLocalStore} from '@modules'
import {PrimaryIconButton} from 'centric-ui-components';
import * as css from './CreateProductsDropTarget.css'
import {VipLocalStore} from '@modules'

interface MyProps {
  className?: string
}

class CreateProductsDropTargetStore extends VipLocalStore {
  @observable.ref file: HTMLInputElement = null
}

const CreateProductsDropTarget = observer<MyProps>(function CreateProductsDropTarget({className}) {
    const store = useVipLocalStore((ws) => new CreateProductsDropTargetStore(ws)),
      {catalog, dragDrop: {dragGroup}, strings} = store

  return (
    <div className={classNames(css.addProductContainer, className)}>
      {dragGroup ? (
        <div className={css.dropWrapper}
          //onDrop={dragDrop.createProductsDropTarget_onDrop}
        >
          <DropTarget
            stores={catalog.stores}
            targetType='Catalog_CreateItems'
            title={catalog.catalogItemName}
            className={css.dropTarget}
          />
        </div>
      ) : (
         <Fragment>
           <Tooltip2 content={strings.dropImageHere}>
             <PrimaryIconButton
               aria-label="DropImage"
               onClick={e =>
                 this.file.click()
               }
             >
               <InsertPhoto/>
             </PrimaryIconButton>
           </Tooltip2>
           <input
             ref={el => (this.file = el)}
             type={"file"}
             style={{display: 'none'}}
             multiple
             accept={"image/*"}
             //onChange={}
           />
         </Fragment>)}
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/CreateProductsDropTarget.tsx